const tr = {
  nav: {
    start: "Ana Sayfa",
    about: "Hakkımda",
    topics: "Konular",
    methods: "Çalışma Yöntemlerim",
    pricing: "Ücretler",
    faq: "SSS",
    feedback: "Geri Bildirim",
    contact: "İletişim",
  },
  common: {
    whatsappCta: "WhatsApp ile yazın",
    whatsappCtaLong: "WhatsApp üzerinden ücretsiz ön görüşme",
    whatsappAria: "WhatsApp üzerinden doğrudan iletişime geçin",
    readMore: "Daha fazla bilgi",
    toTopic: "Konuya git",
    newBadge: "Yeni",
    related: "İlgili konular",
    backToTopics: "Tüm konular",
    backToMethods: "Tüm yöntemler",
    onlineBadge: "Online seanslar da mevcut",
    rating: "4,8/5 · 32 Google yorumu",
    skipToContent: "İçeriğe atla",
    menu: "Menü",
    close: "Kapat",
    chapter: "Bölüm",
  },
  wa: {
    message:
      "Merhaba Naciye Hanım, ücretsiz bir ön görüşme için randevu rica ediyorum. Saygılarımla",
  },
  home: {
    overline: "Hipnoz & Psikoterapi Pratiği · Hamburg-Alsterdorf",
    heroLines: ["Netlik.", "Şifa.", "İçsel Özgürlük."],
    heroSub:
      "Hipnoz, psikoterapi ve danışmanlık – anlayışlı, kültüre duyarlı ve çözüm odaklı. Türkçe ve Almanca, pratikte ve online.",
    ctaPrimary: "Ön görüşme planlayın",
    ctaSecondary: "Konuları keşfedin",
    marquee: [
      "Travma",
      "Kaygı & Fobiler",
      "Depresyon",
      "Öz Değer",
      "Kilo",
      "Sigarayı Bırakma",
      "Yas",
      "Tükenmişlik",
      "Sınav Kaygısı",
      "Kültüre Duyarlı Terapi",
    ],
    manifesto: {
      overline: "Yaklaşımım",
      title: "Birlikte yürüdüğümüz yolda üç adım",
      chapters: [
        {
          title: "Anlamak",
          text: "Her belirtinin bir hikâyesi vardır. Ücretsiz ön görüşmede sizi dinlerim – yargılamadan, sizin hızınızda, eşit göz hizasında.",
        },
        {
          title: "Çözmek",
          text: "Hipnoz, Havening ve EFT ile sorunların köküne, yani bilinçaltına ulaşırız. Nazik, güvenli ve bilimsel temelli.",
        },
        {
          title: "Güçlendirmek",
          text: "Her seanstan yeni içsel güçlerle ayrılırsınız – daha huzurlu, özgüvenli ve özgür bir yaşam için.",
        },
      ],
    },
    topics: {
      overline: "Size nasıl yardımcı olabilirim?",
      title: "Konular & Uygulamalar",
      sub: "Travmadan sigarayı bırakmaya: Sizi meşgul eden konuya hızlıca cevap bulun.",
    },
    methods: {
      overline: "Bütünleşik & kişiye özel",
      title: "Çalışma Yöntemlerim",
      sub: "Sekiz kanıtlanmış yöntem, tek hedef: kalıcı değişim. Size uygun olanı birlikte belirleriz.",
      cta: "Tüm yöntemleri görün",
    },
    about: {
      overline: "Terapistiniz",
      title: "Naciye Rafiq-Arli",
      text: "Psikoterapi alanında Heilpraktiker, Hamburg doğumlu, dört çocuk annesi. İnsanlara bütüncül bir şekilde eşlik ediyorum – empatik, kültüre duyarlı ve gönülden.",
      facts: [
        "Psikoterapi Heilpraktikeri",
        "Türkçe · Almanca",
        "Yüz yüze & online seanslar",
      ],
      cta: "Hakkımda daha fazla",
    },
    testimonials: {
      overline: "Deneyimler",
      title: "Danışanlarım ne diyor?",
      items: [
        {
          quote:
            "Daha birkaç seans sonra iyileşme yolunda büyük adımlar hissettim ve çevremden çok olumlu geri bildirimler aldım.",
        },
        {
          quote:
            "Kısa sürede büyük değişimler gördüm ve travma ya da kaygı bozukluğu yaşayan herkese tavsiye ederim.",
        },
      ],
    },
    ctaBand: {
      title: "İlk adım ücretsiz.",
      text: "Telefonda ön görüşme (30 dakika) – ücretsiz ve bağlayıcı değil. Bana WhatsApp üzerinden yazmanız yeterli.",
      button: "WhatsApp ile başlayın",
    },
    anfahrt: {
      overline: "Ulaşım",
      title: "Pratiğe nasıl ulaşırsınız",
      text: "Hamburg-Alsterdorf'ta Traute-Lafrenz-Straße 161 – otobüs ve trenle kolay ulaşım. Yakın çevrede otopark bulunur. Pek çok seansı online da sunuyorum.",
      routeCta: "Google Maps'te rota planlayın",
      mapTitle: "Harita: Hipnoz & Psikoterapi Pratiği, Traute-Lafrenz-Straße 161, Hamburg-Alsterdorf",
    },
    values: ["Empatik", "Güven veren", "Çözüm odaklı", "Kişiye özel"],
    support: {
      overline: "Destek",
      title: "Size nasıl destek olabilirim",
    },
    approach: {
      overline: "Terapötik yaklaşımım",
      title: "Kalıcı değişim için modern yöntemler",
      rows: [
        { key: "hypnose", title: "Hipnoz", text: "Olumlu değişimleri mümkün kılmak için bilinçaltına erişim." },
        { key: "eft", title: "EFT (Duygusal Özgürleşme Teknikleri)", text: "Duygusal blokajları ve stresi çözen vuruş tekniği." },
        { key: "havening", title: "Havening", text: "Sinir sistemini yatıştıran nazik dokunma teknikleri." },
        { key: "gespraech", title: "Konuşma psikoterapisi", text: "Anlamak, düşünmek ve yeni bakış açıları geliştirmek." },
      ],
      cta: "Çalışma yöntemlerim hakkında",
    },
  },
  topics: {
    pageOverline: "Uygulamalar",
    pageTitle: "Bana gelebileceğiniz konular",
    pageSub:
      "Teknik terimler olmadan açıkça anlatıldı: Konunun arkasında ne var ve birlikte nasıl çözeriz?",
    items: {
      trauma: {
        badge: "Yeni",
        title: "Travmayı anlamak & çözmek",
        teaser:
          "Zorlayıcı deneyimler yıllarca etkisini sürdürebilir. Nazik ve etkili yöntemlerle sizi tutan şeyi çözeriz.",
        sections: [
          {
            h: "Travma nedir?",
            paras: [
              "Travma, bir deneyimin o anda işlenemeyecek kadar ağır olmasıyla oluşur – örneğin bir kaza, kayıp, şiddet veya istismar. Beden ve ruh, yaşananları sanki tehlike hâlâ sürüyormuş gibi kaydeder.",
              "Her zor deneyim travmaya dönüşmez. Belirleyici olan, sinir sisteminin olayı nasıl değerlendirdiği ve sonrasında kendini yeniden güvende hissedip hissedemediğidir.",
            ],
          },
          {
            h: "Travma nasıl etki eder?",
            paras: [
              "Olası sonuçlar: uyku sorunları, iç huzursuzluğu, kabuslar, ani kaygı, konsantrasyon bozukluğu veya nedeni belirsiz bedensel şikâyetler. Pek çok kişi, yaşananları hatırlatan yer, insan ve durumlardan kaçınır.",
              "Travma çoğu zaman başka konuların da arkasındadır: kaygı bozuklukları, depresyon, duygusal yeme veya düşük öz değer.",
            ],
          },
          {
            h: "Pratiğimde travmayı nasıl tedavi ediyorum",
            paras: [
              "Temel yöntemim Havening'dir – ağır anıları nazik dokunuşlarla yatıştıran ve duygusal yükünü çözen psikosensörik bir yöntemdir. Buna ek olarak bilinçaltı nedenleri bulmak için regresif hipnoz, nazik rahatlama için EFT ve taşıyıcı zemin olarak danışan merkezli konuşma terapisi uygularım.",
              "Önemli: Tempoyu siz belirlersiniz. Her şey güvenli bir çerçevede gerçekleşir – ve kontrol her zaman sizdedir.",
            ],
          },
          {
            h: "Bilmekte fayda var",
            paras: [
              "Hipnoterapi 2006 yılında Almanya'da Bilimsel Danışma Kurulu tarafından bilimsel temelli psikoterapötik yöntem olarak kabul edilmiştir. Pek çok danışan birkaç seans sonra belirgin bir rahatlama hisseder.",
            ],
          },
        ],
        related: ["angst", "depression", "selbstwert", "gewicht"],
      },
      angst: {
        title: "Kaygı bozukluklarını aşmak",
        teaser:
          "Kaygı bizi korumak içindir – ama bazen kontrolden çıkar. Hipnoz ve davranış terapisiyle nedenini bulur ve çözeriz.",
        sections: [
          {
            h: "Kaygı bozukluğu nedir?",
            paras: [
              "Kaygı doğal bir koruma mekanizmasıdır. Çok güçlendiğinde, gerçek bir neden olmadan ortaya çıktığında veya günlük yaşamı belirlediğinde kaygı bozukluğundan söz edilir – örneğin panik atak, sosyal kaygı veya fobiler.",
            ],
          },
          {
            h: "Nedenleri & belirtileri",
            paras: [
              "Yaygın nedenler: travmatik çocukluk deneyimleri, uzun süreli stres veya olumsuz öğrenme deneyimleri. Kaygı bedensel olarak – çarpıntı, terleme, titreme, nefes darlığı – ve ruhsal olarak, sürekli endişe veya kaçınma şeklinde kendini gösterir.",
              "Tedavi edilmezse kaygı bozukluğu depresyona dönüşebilir. Bu yüzden erken harekete geçmek önemlidir.",
            ],
            list: [
              "Basit fobiler: hayvanlar, yükseklik, iğne korkusu vb.",
              "Karmaşık fobiler: örn. sosyal fobi, agorafobi",
              "Gizli fobiler: kaygı dolaylı olarak, örn. bedensel şikâyetlerle kendini gösterir",
            ],
          },
          {
            h: "Kaygıyı nasıl tedavi ediyorum",
            paras: [
              "Regresif, açığa çıkarıcı kısa süreli hipnoterapi ile kaygının kökünü buluruz – çoğu zaman çoktan unutulmuş deneyimlerde. Bilişsel davranış terapisiyle birleştiğinde kaygı zeminini kaybeder.",
              "Genellikle birkaç seans, fark edilir bir değişim yaşamanız için yeterlidir.",
            ],
          },
        ],
        related: ["trauma", "depression", "selbstwert"],
      },
      depression: {
        title: "Depresyon – yaşama dönüş yolları",
        teaser:
          "Sevinç kaybolduğunda ve her şey ağırlaştığında: Gizli nedenleri bulur, yaşam enerjinizi yeniden harekete geçiririz.",
        sections: [
          {
            h: "Tipik belirtiler",
            paras: [
              "Depresyon; çökkün ruh hali, ilgi kaybı, takıntılı düşünme, keder, hareketsizlik, konsantrasyon sorunları ve uykunun bile iyileştirmediği derin bir yorgunluk ile kendini gösterir.",
            ],
          },
          {
            h: "Depresyon nereden gelir?",
            paras: [
              "Nedenler çoğu zaman bilinçaltında gizlidir: uzun süreli stres, tükenmişlik, çözülmemiş çatışmalar veya bir kaygı bozukluğu depresyonu tetikleyebilir. Çoğu kişi bu noktaya nasıl geldiğini kendisi de bilmez.",
            ],
          },
          {
            h: "Tedavi yöntemim",
            paras: [
              "Regresif hipnoz ile bilinçaltındaki tetikleyicileri bulur ve kökünden çözeriz. Bilişsel davranış terapisi ayrıca yorucu düşünce kalıplarını adım adım değiştirmeye yardımcı olur.",
            ],
          },
        ],
        related: ["angst", "trauma", "trauer"],
      },
      selbstwert: {
        title: "Öz değeri güçlendirmek",
        teaser:
          "Çekingenlik, kendinden şüphe, cesaret edememek: Hipnoz, içinizdeki beklenmedik güçleri serbest bırakır.",
        sections: [
          {
            h: "Düşük öz değer nasıl görünür?",
            paras: [
              "Çekingenlik, kararsızlık, kendini savunamama veya asla yeterince iyi olmama hissi olarak kendini gösterir – özel yaşamda da iş hayatında da. Pratiğimde en sık eşlik eden konulardan biridir.",
            ],
          },
          {
            h: "Nereden gelir?",
            paras: [
              "Kökleri çoğu zaman çocukluktadır: eleştirel sesler, kırıcı deneyimler veya travmalar, kendimiz hakkındaki iç resmimizi bugüne kadar şekillendirir.",
            ],
          },
          {
            h: "Hipnoz nasıl yardımcı olur?",
            paras: [
              "Trans sırasında eski blokajları çözer ve yeni, güçlendirici inançları telkin ve afirmasyonla doğrudan bilinçaltına yerleştiririz. Böylece zor durumlarda bile taşıyan bir öz değer gelişir.",
            ],
          },
        ],
        related: ["trauma", "angst", "depression"],
      },
      gewicht: {
        title: "Hipnozla kilo vermek",
        teaser:
          "Diyetler zihinde başarısız olur. Hipnoz, yeme davranışını yönetildiği yerde – bilinçaltında – değiştirir.",
        sections: [
          {
            h: "İki yol – size uygun olan",
            paras: [
              "Hafif kilo fazlasında telkin hipnozu ile çalışırım: Yeni, sağlıklı yeme alışkanlıkları doğrudan yerleştirilir. Daha yüksek kilo fazlası ve duygusal yeme durumunda, daha derin nedenleri çözmek için analitik hipnozu (hipnoanaliz) kullanırım.",
            ],
          },
          {
            h: "Duygusal yemeyi anlamak",
            paras: [
              "Yemek çoğu zaman bir ikame haline gelir: kaygıları, yası, travmayı veya ilişki çatışmalarını bastırır. Ruhsal açlık sürdükçe neredeyse her diyet başarısız olur. Hipnoanaliz tam burada devreye girer.",
            ],
          },
          {
            h: "Bilimsel olarak kanıtlanmış",
            paras: [
              "Tübingen Üniversitesi'nden Prof. Dirk Revenstorf, bir çalışmayla hipnozun kilo vermede kalıcı etkili olduğunu – yoyo etkisi olmadan – kanıtlamıştır.",
            ],
          },
        ],
        related: ["trauma", "selbstwert"],
      },
      rauchen: {
        title: "Sigarayı bırakmak",
        teaser:
          "Sigara içmek bilinçsiz bir koşullanmadır. Tek bir yoğun seansta bunu çözeriz – kalıcı olarak dumansız.",
        sections: [
          {
            h: "Neden irade tek başına yetmez",
            paras: [
              "Alışkanlıklarımız bilinçaltında yatar. Bu yüzden bantlar, uygulamalar ve iyi niyetler çoğu zaman başarısız olur: Sigaranın yerleştiği düzeye ulaşamazlar.",
            ],
          },
          {
            h: "Tek yoğun seansta dumansız",
            paras: [
              "Yaklaşık 2–4 saatlik tek bir seansta koşullanmayı çözer ve sigarasız yeni yaşamınızı yerleştiririz. Bu yöntemin başarı oranı yüksektir – pek çok danışanım evine dumansız döner ve öyle kalır.",
              "Yatırım: KDV dahil 999 € – tüm yoğun program için.",
            ],
          },
        ],
        related: ["gewicht", "selbstwert"],
      },
      trauer: {
        title: "Yas tutmak & manevi destek",
        teaser:
          "Kayıp, vedalar, zor kararlar: Bunu tek başınıza taşımak zorunda değilsiniz. Anlayışlı eşlik – gizlilik yükümlülüğü altında.",
        sections: [
          {
            h: "Manevi eşlik",
            paras: [
              "Yas, alan ve zaman ister – ve bazen olanı kaldırabilen bir insan. Kayıplar, vedalar, zor kararlar ve derin hayal kırıklıklarında size eşlik ederim.",
              "Manevi destek veren biri olarak gizlilik yükümlülüğü altındayım. Bana emanet ettiğiniz her şey korunur.",
            ],
          },
          {
            h: "Bu teklif kimler için?",
            paras: [
              "Sevdiği birini kaybedenler, önemli bir yaşam kararının eşiğinde olanlar veya varoluşsal bir krizde bulunan herkes için – din ve dünya görüşünden bağımsız olarak.",
            ],
          },
        ],
        related: ["depression", "trauma"],
      },
      paartherapie: {
        title: "Çift Terapisi & Evlilik Danışmanlığı",
        teaser:
          "Konuşmalar zorlaştığında ve yakınlık kaybolduğunda: yeniden diyaloğa girmek – yapılandırılmış ve taraf tutmadan.",
        sections: [
          {
            h: "Çift terapisi ne zaman yardımcı olur?",
            paras: [
              "Her ilişki kriz yaşar: tekrarlayan çatışmalar, kısır döngüye giren konuşmalar, güven kırılmaları veya birbirinden uzaklaşma hissi. Büyük değişimler – çocuk, taşınma, mesleki dönüm noktaları – çiftleri yeni görevlerle karşı karşıya bırakır.",
              "Çift terapisinde bu konular güvenli bir alan bulur. Çatışmaların arkasında ne olduğuna ve her iki tarafın kendini yeniden görülmüş hissetmek için neye ihtiyacı olduğuna birlikte bakarız.",
            ],
          },
          {
            h: "Çiftlerle nasıl çalışıyorum?",
            paras: [
              "Danışan merkezli ve kültüre duyarlı çalışırım – her iki bakış açısı da taraf tutmadan eşit şekilde yer bulur. Yapılandırılmış görüşmelerde kalıpları, beklentileri ve karşılanmamış ihtiyaçları netleştiririz.",
              "Kişisel konular ilişkiyi zorluyorsa – örneğin eski yaralar veya kaygılar – tamamlayıcı olarak bireysel hipnoz, EFT veya Havening ile çalışabilirim. İlişkideki kültürel farklılıkları da deneyimle ele alırım.",
            ],
          },
          {
            h: "Çerçeve & ücret",
            paras: [
              "Çift koçluğu ve çocuklu aile koçluğu: 60 dakika, KDV dahil 390 € – online da mümkün. İlk adım her zamanki gibi ücretsiz telefon ön görüşmesidir (30 dakika).",
            ],
          },
        ],
        related: ["trauer", "selbstwert", "angst"],
      },
      beispiele: {
        title: "Tedavi örneklerine genel bakış",
        teaser:
          "Çalışmalarımın tüm yelpazesine bir bakış – A'dan kaygıya, Z'den hedefe ulaşmaya.",
        sections: [
          {
            h: "Diğer uygulama alanları",
            paras: [
              "Odak konularının yanı sıra pek çok alanda size eşlik ederim. Bana yazmanız yeterli – ücretsiz ön görüşmede sizin için doğru yolu birlikte belirleriz.",
            ],
            list: [
              "Kaygı & panik bozuklukları",
              "Tükenmişlik",
              "Depresyon",
              "Kıskançlık",
              "Gevşeme",
              "Uçuş korkusu",
              "Kilo verme",
              "Konsantrasyon",
              "Sahne korkusu",
              "Fobiler",
              "Erteleme",
              "Sınav kaygısı",
              "Sigarayı bırakma",
              "Otohipnoz",
              "Öz değer güçlendirme",
              "Cinsel işlev bozuklukları",
              "Spor hipnozu",
              "Yas",
              "Konuşma korkusu",
              "Hedefe ulaşma",
            ],
          },
        ],
        related: ["trauma", "angst", "rauchen"],
      },
    },
  },
  methods: {
    pageOverline: "Çalışma yöntemlerim",
    pageTitle: "Sekiz yöntem, tek hedef: Sizin değişiminiz",
    pageSub:
      "Bütünleşik çalışırım – yani kanıtlanmış yöntemleri size uyan bir yolda birleştiririm.",
    items: {
      hypnose: {
        title: "Klinik Hipnoz",
        teaser:
          "Çalışmalarımın merkezi: değişimin mümkün olduğu doğal bir derin gevşeme hali.",
        sections: [
          {
            h: "Hipnoz nedir?",
            paras: [
              "Hipnoz, uyanıklık ile uyku arasında değişmiş bir bilinç halidir. Bu hissi tanırsınız: öyle bir kitaba dalmışsınızdır ki çevrenizdeki her şeyi unutursunuz.",
              "İnsanların yaklaşık yüzde 90'ı yeterli ölçüde transa girebilir. Ve önemli: Seans boyunca tam kontrol sizdedir.",
            ],
          },
          {
            h: "Bilimsel olarak tanınmış",
            paras: [
              "Hipnoterapi 2006 yılında Almanya'da Bilimsel Danışma Kurulu tarafından bilimsel temelli psikoterapötik yöntem olarak kabul edilmiştir. Trans sırasında solunum ve kalp-damar sistemi yatışır, stres hormonu seviyesi düşer.",
              "G. A. Estabrooks, Milton Erickson ve Dave Elman teknikleriyle çalışıyorum.",
            ],
          },
          {
            h: "Tedavi nasıl ilerler?",
            paras: [
              "Ücretsiz telefon ön görüşmesiyle başlarız. İlk seansta (yaklaşık 2–3 saat) kapsamlı bir öykü görüşmesi yaparız. Asıl trans çalışması genellikle takip eden seansta başlar.",
            ],
          },
        ],
      },
      havening: {
        title: "Havening",
        teaser:
          "Nazik dokunuşlar, derin etki: travma, kaygı ve blokajları çözen en modern yöntemlerden biri.",
        sections: [
          {
            h: "Havening nedir?",
            paras: [
              "Havening – İngilizce 'haven': liman, sığınak – Amerikalı doktor ve nörobilimci Dr. Ronald Ruden tarafından geliştirilmiştir. Psikosensörik yöntemler arasındadır: Psikolojiyi olumlu etkilemek için birden fazla duyu uyaranı birleştirilir.",
              "'Havening Touch' denilen yöntem – yüz, avuç içi ve kollara uygulanan düzenli, okşayıcı dokunuşlar – sinir sistemini kanıtlanabilir ve kalıcı şekilde yatıştırır.",
            ],
          },
          {
            h: "Nasıl etki eder?",
            paras: [
              "Uygulama sırasında beyin frekansı delta dalgaları bölgesine kayar – derin uyku, hücre yenilenmesi ve iyileşme süreçleriyle bağlantılı frekans. Hissedilen stres şaşırtıcı hızla azalır.",
              "Etkiyi görünür kılmak için yükünüzü başta ve sonda 0–10 arası bir ölçekte kendiniz değerlendirirsiniz (SUD değeri). 9'dan 5–6'ya düşüşler sık görülür.",
            ],
          },
          {
            h: "Kimler için ve ne kadar sürer?",
            paras: [
              "Havening, travma, kaygı halleri ve blokajların çözümünde temel yöntemimdir. Genellikle 4–5 seanstan fazlası gerekmez. Sorunun kökü bulunduğunda rahatlama kalıcı olur.",
            ],
          },
        ],
      },
      gespraechstherapie: {
        title: "Danışan Merkezli Konuşma Terapisi",
        teaser:
          "Merkezde siz varsınız – sorununuz değil. Carl R. Rogers'ın kişi merkezli yaklaşımına göre.",
        sections: [
          {
            h: "Temel tutum",
            paras: [
              "Bu yöntem Carl R. Rogers'ın kişi merkezli yaklaşımına dayanır: olumlu değer verme, önyargısızlık ve göz hizasında gerçek karşılaşma.",
              "Odak, sorununuz değil, bir insan olarak sizsiniz. Bu güvenli alanda kendi cevaplarınızı bulursunuz.",
            ],
          },
          {
            h: "Neyi taşır?",
            paras: [
              "Konuşma terapisi, tüm çalışmalarımın taşıyıcı ilişki zemini dir – diğer her yönteme eşlik eder ve değişimi mümkün kılan güveni oluşturur.",
            ],
          },
        ],
      },
      kultursensibel: {
        title: "Kültüre Duyarlı Terapi & Danışmanlık",
        teaser:
          "Hikâyeniz, kültürünüz, diliniz: Geçmişinizi anlayan ve ciddiye alan bir terapi.",
        sections: [
          {
            h: "Kültüre duyarlı ne demektir?",
            paras: [
              "Göç, ruhsal sağlığı şekillendirir – vatan kaybı, dil engelleri, ayrımcılık veya iki kültür arasında denge kurma çabasıyla. Kültüre duyarlı terapide bu deneyimler tedaviye aktif olarak dahil edilir.",
            ],
          },
          {
            h: "Standart değil, ihtiyaca yönelik",
            paras: [
              "Hedef, gerçekten size uyan bir tedavidir – değerlerinize, ailenize, yaşam dünyanıza uygun. Seansları Türkçe ve Almanca sunuyorum.",
            ],
          },
        ],
      },
      thetahealing: {
        title: "ThetaHealing®",
        teaser:
          "Engelleyici inanç kalıplarını fark edip dönüştürmek – beden, zihin ve ruh için enerjik bir yöntem.",
        sections: [
          {
            h: "ThetaHealing nedir?",
            paras: [
              "ThetaHealing enerjik bir eğitim ve meditasyon yöntemidir. Bizi yöneten derin inanç kalıplarıyla çalışır – çoğu zaman erken çocukluktan beri: 'Yeterince iyi değilim', 'Başarısız olmamalıyım'.",
            ],
          },
          {
            h: "Hedef",
            paras: [
              "Eski inançlar bulunup güçlendirici yenileriyle değiştirilerek blokajlar ve korkular çözülür. Böylece beden, zihin ve ruhun öz iyileştirme güçleri harekete geçer.",
            ],
          },
        ],
      },
      beratung: {
        title: "Psikolojik Danışmanlık",
        teaser:
          "Hayat yeniden şekillendiğinde: Geçiş dönemlerinde netlik ve yön.",
        sections: [
          {
            h: "Danışmanlık ne zaman yardımcı olur?",
            paras: [
              "Yaşam koşulları değişir – ve bazen yeni bir düzen gerekir. Psikolojik danışmanlık; memnuniyetsizlik, kaygılar, kararsızlık, keder ve karar verme güçlüklerinde destek olur.",
            ],
          },
          {
            h: "Tipik konular",
            paras: [
              "Doyumsuz bir ilişki, iş sorunları, sürekli stres, sigara veya kilo fazlası: Danışmanlıkta neye ihtiyacınız olduğuna – ve hangi yolun doğru olduğuna – birlikte bakarız. Terapi, hastalık değeri taşıyan konuları tedavi eder; koçluk ve danışmanlık kişiliğinizi ve yaşam tasarımınızı güçlendirir.",
            ],
          },
        ],
      },
      coaching: {
        title: "Yoğun Koçluk",
        teaser:
          "Hızlı netliğe ihtiyaç duyanlar için: ilişkiler, kariyer ve kısır döngüye girmiş kalıplar için odaklı koçluk.",
        sections: [
          {
            h: "Yoğun koçluk ne için?",
            paras: [
              "Bazı sorular uzun bir terapi değil, odaklı netlik ister: aile veya arkadaşlık ilişkilerinde çatışmalar, mesleki yeniden yönelim, kendi işinizi kurma adımı.",
            ],
          },
          {
            h: "Faydası",
            paras: [
              "Kısır döngüye girmiş düşünce ve davranış kalıplarını çözer, durumunuz için somut çözümler geliştiririz – odaklı, pratik ve hedeflerinize yönelik.",
            ],
          },
        ],
      },
      lebensstil: {
        title: "Bireysel Psikoloji Yaşam Tarzı Danışmanlığı",
        teaser:
          "Alfred Adler'e göre: Sizi neyin harekete geçirdiğini anlayın – ve davranış kalıplarını hedefli değiştirin.",
        sections: [
          {
            h: "Yaklaşım",
            paras: [
              "Alfred Adler'in bireysel psikolojisi insanı bir bütün olarak görür: Biçimlendirici deneyimler 'yaşam tarzımızı' – düşünme, hissetme ve davranma biçimimizi – oluşturur.",
            ],
          },
          {
            h: "Uygulama alanları",
            paras: [
              "Kişilik danışmanlığı, çatışma danışmanlığı, karar verme, netlik kazanma, davranış kalıplarını anlama ve değiştirme – ve çok pratik olarak: ebeveynler için çocuk eğitimi danışmanlığı.",
            ],
          },
        ],
      },
    },
  },
  pricing: {
    pageOverline: "Şeffaf & adil",
    pageTitle: "Ücretler",
    pageSub:
      "Bir seansın ücretini en baştan bilirsiniz. Tüm fiyatlara %19 KDV dahildir.",
    items: [
      {
        name: "Ön görüşme (telefon)",
        duration: "30 dk.",
        price: "Ücretsiz",
        highlight: true,
        note: "Tanışma ve konunuzun netleştirilmesi – bağlayıcı değildir",
      },
      {
        name: "Danışmanlık & Hipnoz koçluğu",
        duration: "60 dk.",
        price: "340 €",
        note: "Size uygun yöntem karışımıyla bireysel seans",
      },
      {
        name: "Çift koçluğu / çocuklu aile koçluğu",
        duration: "60 dk.",
        price: "390 €",
        note: "Çiftler ve çocuklu aileler için",
      },
      {
        name: "Hipnozla telkin yoluyla kilo verme",
        duration: "60 dk.",
        price: "340 €",
        note: "Sağlıklı yeme alışkanlıklarının bilinçaltına yerleştirilmesi",
      },
      {
        name: "Hipnozla sigarasız yaşam (yoğun seans)",
        duration: "120–180 dk.",
        price: "999 €",
        note: "Yüksek başarı oranlı tek yoğun seans",
      },
      {
        name: "Hafta sonu & resmi tatil farkı",
        duration: "60 dk. başına",
        price: "50 €",
        note: "Hafta sonu veya resmi tatillerdeki randevular için ek ücret",
      },
    ],
    notes: [
      "Tüm fiyatlara %19 KDV dahildir.",
      "Uzaktan gelen danışanlar için paketler: Fiyat istek üzerine.",
      "Ödeme seans başında nakit olarak alınır. Yalnızca kendi ödeyen danışanlar.",
      "Özel sağlık sigortaları masrafları genellikle karşılar.",
    ],
  },
  faq: {
    pageOverline: "Bilmekte fayda var",
    pageTitle: "Sık sorulan sorular",
    pageSub: "En çok aranan cevaplar – kısa ve anlaşılır.",
    items: [
      {
        q: "Terapi ile koçluk arasındaki fark nedir?",
        a: "Terapi, hastalık değeri taşıyan konuları tedavi eder – örneğin kaygı bozuklukları, depresyon veya travma. Koçluk ve danışmanlık kişisel gelişime ve hastalık değeri taşımayan konulara hizmet eder, örneğin kilo, stres yönetimi, sigarayı bırakma veya doğuma hazırlık.",
      },
      {
        q: "Hipnoz güvenli mi?",
        a: "Evet. Hipnoz, doğal bir derin gevşeme halidir. Seans boyunca tam kontrol sizdedir ve transı istediğiniz an sonlandırabilirsiniz. Hipnoterapi Almanya'da 2006'dan beri bilimsel olarak tanınmaktadır.",
      },
      {
        q: "Trans nasıl bir his?",
        a: "Herkes transı farklı yaşar. Çoğu kişi bunu hoş, derin bir gevşeme olarak tanımlar – bir kitaba ya da filme tamamen dalmış olma hissine benzer. Her şeyi duyarsınız ve istediğiniz an tepki verebilirsiniz.",
      },
      {
        q: "Etkisi kalıcı mı?",
        a: "Evet, çünkü değişimler bilinçaltına – alışkanlık ve kalıpların oluştuğu yere – yerleştirilir. Neden çözüldüğünde rahatlama genellikle kalıcı olur.",
      },
      {
        q: "Hipnoz hangi konularda yardımcı olur?",
        a: "Uygulama alanı geniştir: fobiler, stres azaltma, gevşeme, uyku bozuklukları, sigarayı bırakma, kilo, performans artışı, sınav kaygısı, spor hipnozu, yas ve ayrılık acısı, ilişki sorunları, alerjiler, özgüven, tıbbi hipnoz, çocuk hipnozu, rüya yolculukları, Time Line ve regresyon.",
      },
      {
        q: "Kaç seansa ihtiyacım var?",
        a: "Bu konuya bağlıdır. Sigarayı bırakma çoğu zaman tek bir yoğun seansta başarılır. Kaygı veya travmada genellikle birkaç seans yeterlidir – Havening çoğunlukla 4–5 randevu gerektirir. Ücretsiz ön görüşmede size dürüst bir değerlendirme sunarım.",
      },
      {
        q: "Online seans var mı?",
        a: "Evet, pek çok seansı online da sunuyorum – evinizin rahatlığında, pratiktekiyle aynı özenle.",
      },
      {
        q: "Sağlık sigortası masrafları karşılıyor mu?",
        a: "Pratiğim kendi ödeyen danışanlara yöneliktir. Özel sağlık sigortaları masrafları genellikle karşılar – lütfen bunu önceden sigortanızla netleştirin.",
      },
    ],
  },
  about: {
    pageOverline: "Hakkımda",
    pageTitle: "Naciye Rafiq-Arli",
    pageSub: "Psikoterapi Heilpraktikeri – deneyim, uzmanlık ve gönülle.",
    intro:
      "Ben Naciye Rafiq-Arli, Hamburg doğumluyum, dört çocuk annesiyim, farmasötik alanda PTA eğitimim var ve psikoterapi alanında Heilpraktiker'im. Odak noktam hipnoz, konuşma terapisi ve manevi eşliktir. İnsanlara bütüncül olarak eşlik ediyorum – empatik, kültüre duyarlı ve çözüm odaklı.",
    facts: [
      { label: "Doğum", value: "1976, Hamburg" },
      { label: "Yetkinlik", value: "Psikoterapi Heilpraktikeri" },
      { label: "Eğitim", value: "PTA / farmasötik alan, hipnoz eğitimi" },
      { label: "Aile", value: "Dört çocuk annesi" },
      { label: "Gönüllülük", value: "Rahmet e.V. kurucu üyesi – Hamburg Müslüman manevi destek" },
      { label: "Diller", value: "Türkçe · Almanca" },
    ],
    approach: {
      title: "Terapi yaklaşımım",
      text: "Hipnoz, EFT, Havening ve psikoterapötik yöntemlerle bütünleşik çalışıyorum. Hipnoterapi, içsel süreçleri hedefli işlemek için doğal trans halini kullanır. EFT ve Havening duygusal blokajları nazikçe çözmeye yardımcı olur. Buna, kalıcı değişim ve içsel denge için anlayışlı, danışan merkezli bir konuşma tarzı eşlik eder.",
    },
    engagement: {
      title: "Gönüllü çalışmam",
      text: "Rahmet e.V. kurucu üyesi olarak Hamburg'da Müslüman manevi destek çalışmalarına katılıyorum – deneyim, uzmanlık ve gönülle.",
    },
    press: {
      title: "Basın & Medya",
      sub: "Gazete ve radyoda – şimdiye kadarki medya görünümlerinden bir seçki.",
      articleLabel: "Gazete yazısı",
      radioLabel: "Radyo röportajı",
      viewCta: "Görüntüle",
    },
    gallery: {
      title: "Pratiğe bir bakış",
      alts: {
        room: "Eğimli tavan altında koltuklu aydınlık ve sakin terapi odası",
        hafencity: "Naciye Rafiq-Arli, Hamburg HafenCity önünde",
        certificates: "Pratiğin sertifika duvarı",
      },
    },
    helpList: {
      title: "Şu konularda yardımcı olabilirim",
      items: [
        "Kaygılar & blokajlar: fobiler, takıntı, depresyon, travma",
        "Stres & tükenme: tükenmişlik, iç huzursuzluğu, uykusuzluk",
        "Kişisel gelişim: özgüven, hedef bulma, yaşam krizleri",
        "Davranış değişikliği: sigarayı bırakma, kilo verme",
        "Kadın konuları & aile: çocuk isteği, doğum, ilişki, çocuk eğitimi",
      ],
    },
  },
  contact: {
    pageOverline: "İletişim",
    pageTitle: "Konunuzu konuşalım",
    pageSub:
      "En kolay yol: Bana WhatsApp üzerinden yazın. En kısa sürede size dönerim.",
    whatsappTitle: "WhatsApp – doğrudan & kolay",
    whatsappText:
      "Tek tık, hazır bir mesajla sohbeti açar – sadece 'Gönder'e dokunmanız yeterli.",
    whatsappPreviewLabel: "Bana mesajınız:",
    phoneTitle: "Telefon",
    emailTitle: "E-posta",
    addressTitle: "Pratik",
    addressNote: "Hamburg-Alsterdorf – otobüs ve trenle kolay ulaşım, yakınlarda otopark.",
    onlineTitle: "Online seanslar",
    onlineText:
      "Hamburg'a gelmenize gerek yok: Pek çok seansı online da sunuyorum – aynı özen ve etkiyle.",
    socialTitle: "Beni takip edin",
  },
  footer: {
    tagline: "Hamburg-Alsterdorf'ta Hipnoz & Psikoterapi Pratiği.",
    navTitle: "Navigasyon",
    contactTitle: "İletişim",
    legalTitle: "Yasal",
    imprint: "Künye",
    privacy: "Veri koruma",
    copyright: "© 2026 Naciye Rafiq-Arli. Tüm hakları saklıdır.",
  },
  feedback: {
    pageOverline: "Deneyimle gelen güven",
    pageTitle: "Geri Bildirim & Değerlendirmeler",
    pageSub:
      "Farklı kaynaklardan danışan görüşleri – kendinize dürüst bir resim oluşturabilmeniz için.",
    sourcesTitle: "Değerlendirmelere genel bakış",
    googleCta: "Google'da görüntüle",
    jamedaCta: "Jameda'da görüntüle",
    jamedaCount: "11 hasta geri bildirimi",
    reportsCta: "Raporlara git",
    reportsCount: "6 ayrıntılı rapor – orijinal metin",
    shortTitle: "Danışan görüşleri",
    reportsTitle: "Deneyim raporları – orijinal metin",
    reportsNote: "Bu deneyim raporları orijinal Almanca metin olarak gösterilmektedir.",
    fromLabel: "Deneyim raporu:",
    sourceLabel: "Kaynak",
    sourceWebsite: "hypnosecoachinghamburg.com",
  },
  cookie: {
    title: "Çerezler & veri koruma",
    text: "Web sitemizi en iyi şekilde tasarlamak ve kullanımı analiz etmek için çerezler ve benzer teknolojiler kullanıyoruz. Hangi çerezlere izin vereceğinize siz karar verirsiniz. Ayrıntılar veri koruma beyanımızdadır.",
    acceptAll: "Tümünü kabul et",
    essentialOnly: "Yalnızca gerekli olanlar",
  },
  legal: {
    imprintTitle: "Künye",
    imprintBlocks: [
      {
        h: "TMG § 5 uyarınca bilgiler",
        paras: [
          "Naciye Rafiq-Arli, Psikoterapi Heilpraktikeri\nTraute-Lafrenz-Straße 161\n22297 Hamburg",
        ],
      },
      {
        h: "İletişim",
        paras: ["Telefon: +49 176 41 800 480\nE-posta: n.rafiq-arli@web.de"],
      },
      {
        h: "Meslek unvanı",
        paras: [
          "Psikoterapi Heilpraktikeri (Almanya'da verilmiştir). Yetkili kurum: Hamburg Sağlık Dairesi.",
        ],
      },
    ],
    privacyTitle: "Veri Koruma Beyanı",
    privacyBlocks: [
      {
        h: "1. Sorumlu birim",
        paras: [
          "Naciye Rafiq-Arli, Traute-Lafrenz-Straße 161, 22297 Hamburg, E-posta: n.rafiq-arli@web.de",
        ],
      },
      {
        h: "2. Kişisel verilerin toplanması ve saklanması",
        paras: [
          "Bu web sitesi formlar aracılığıyla kişisel veri toplamaz ve saklamaz. E-posta, telefon veya WhatsApp ile iletişimde bilgileriniz yalnızca talebinizi yanıtlamak için kullanılır ve üçüncü taraflarla paylaşılmaz.",
        ],
      },
      {
        h: "3. WhatsApp",
        paras: [
          "WhatsApp bağlantısını kullandığınızda bu siteden ayrılırsınız. WhatsApp'ın (Meta Platforms, Inc.) veri koruma kuralları geçerlidir.",
        ],
      },
      {
        h: "4. Haklarınız",
        paras: [
          "Saklanan verileriniz hakkında her zaman bilgi alma, düzeltme ve silme hakkına sahipsiniz. Bunun için yukarıdaki adrese başvurmanız yeterlidir.",
        ],
      },
    ],
  },
};

export default tr;
